require('./optionGroupButton.i18n.json');
require('./optionGroupButton.tpl.html');
require('./optionGroupButtonController.js');

const OptionGroupButtonComponent = {
    templateUrl: '/configuration/formEditor/content/form/componentSettings/optionGroup/optionGroupButton/optionGroupButton.tpl.html',
    controller: 'optionGroupButtonController',
    bindings: {
        selectedField: '<',
        name: '<',
        label: '<',
        buttonLinkText: '<',
        defaultButtonLinkText: '<',
        isDisabled: '<'
    }
};

angular.module('ums.configuration')
    .component('uiOptionGroupButton', OptionGroupButtonComponent);
